import { Button, Flex, Form, Modal, Radio } from 'antd';
import { useCallback, useMemo } from 'react';
import { ReasonsModalProps } from '../common/reasons';
import { BarcodeItemType, LineItemScanType } from '../common/lineItem';

const style: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
};

const ReasonsModal = ({ status, visible, barcodeItems, onClose, onFinish }: ReasonsModalProps) => {
  const [form] = Form.useForm();

  const close = useCallback(() => {
    form.resetFields();
    onClose();
  }, []);

  const finished = useCallback(
    (values: any) => {
      const reason = values.reason;
      const payload: LineItemScanType = {
        status: status.cd,
        barcodeItems: (barcodeItems || []).map((item: string) => {
          return {
            barcode: item,
            reason,
          };
        }),
      };
      onFinish(payload);
    },
    [barcodeItems, status]
  );

  const options = useMemo(() => {
    const reasons = status?.shipmentStatusReasons || [];
    return reasons.map((item: any) => {
      return { value: item.cd, label: item.name };
    });
  }, [status]);

  const handleRadioClick = useCallback(
    (value: string) => {
      const current = form.getFieldValue('reason');
      if (current === value) {
        form.setFieldValue('reason', null);
      } else {
        form.setFieldValue('reason', value);
      }
    },
    [form]
  );

  return (
    <Modal title="Шалтгаан" open={visible} footer={false} width={520} onCancel={() => close()}>
      <Form form={form} onFinish={finished}>
        <Form.Item
          name="reason"
          rules={[{ required: status?.reasonRequired || false, message: 'Шалтгаан сонгоно уу!' }]}
        >
          <Radio.Group style={style}>
            {options.map((option: any, index: number) => {
              return (
                <Radio
                  key={`reasion_${index}`}
                  value={option.value}
                  onClick={() => handleRadioClick(option.value)}
                >
                  {option.label}
                </Radio>
              );
            })}
          </Radio.Group>
        </Form.Item>
        <Flex gap={24} justify="end">
          <Button onClick={() => onClose()}>Болих</Button>
          <Button type="primary" htmlType="submit">
            Илгээх
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};

export default ReasonsModal;
